/** First assistant turn in new Clumse Chat threads (retail / homeowner). */
export const CLUMSE_CHAT_WELCOME_MARKDOWN = `Hi! I'm Clumse AI. Tell me what you need done (photos welcome). I'll ask a few quick questions, share a local cost range when I can, then help you line up vetted pros when you're ready.`;

/** Legacy welcomes stored the label inside the bubble; UI already shows the name above. */
export function stripClumseAiMessagePrefix(text) {
  return String(text || "")
    .replace(/^\*\*Clumse AI\*\*:\s*/i, "")
    .replace(/^Clumse AI:\s*/i, "")
    .trimStart();
}

/** Clumse AI replies must not show em dashes ( - ) in the chat UI. */
export function stripEmDashesFromClumseAiText(text) {
  const s = String(text || "");
  if (!s.includes("\u2014")) return s;
  return s.replace(/\s*\u2014\s*/g, " - ").replace(/\u2014/g, "-");
}

/** When the assistant refers to itself, always use the product name "Clumse AI". */
export function normalizeClumseAiSelfName(text) {
  let s = String(text || "");
  s = s.replace(/\bI'm the Clumse Advisor\b/gi, "I'm Clumse AI");
  s = s.replace(/\bI am the Clumse Advisor\b/gi, "I am Clumse AI");
  s = s.replace(/\bI'm Clumse\b(?!\s*AI\b)/gi, "I'm Clumse AI");
  s = s.replace(/\bI am Clumse\b(?!\s*AI\b)/gi, "I am Clumse AI");
  s = s.replace(/\bthe Clumse Advisor\b/gi, "Clumse AI");
  s = s.replace(/\bClumse Advisor here\b/gi, "Clumse AI here");
  return s;
}

/** Prefix strip + em-dash strip + self-name normalization for assistant bubbles. */
export function formatClumseAiBubbleText(text) {
  return normalizeClumseAiSelfName(
    stripEmDashesFromClumseAiText(stripClumseAiMessagePrefix(text))
  );
}
